import React from "react";
import AnnouncementBar from "../../../../components/AnnouncementBar/AnnouncementBar";
import ContentPageIndex from "../../../../components/SidetabPages/Configuration/ContentPage/ContentPageIndex";

const ContentPage = () => {
  return (
    <>
      <AnnouncementBar />
      <ContentPageIndex />
    </>
  );
};
export default ContentPage;
